const LOCAL_STORAGE_KEY = "fitfrik-local-auth";

function readLocalUsers() {
  try {
    return JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY) || "[]");
  } catch {
    return [];
  }
}

function writeLocalUsers(users) {
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(users));
}

function normalizeEmail(email) {
  return String(email || "").trim().toLowerCase();
}

export function registerLocalUser(name, email, password, consent = {}) {
  const users = readLocalUsers();
  const normalizedEmail = normalizeEmail(email);
  const existing = users.find((u) => u.email === normalizedEmail);
  if (existing) {
    throw new Error("Email already registered");
  }

  const user = {
    user_id: `local-${Date.now()}`,
    email: normalizedEmail,
    name: name || normalizedEmail.split("@")?.[0] || "User",
    role: "user",
    onboarding_complete: false,
    is_superadmin: false,
    created_at: new Date().toISOString(),
    marketing_consent: !!consent.marketing_consent,
  };

  users.push({ ...user, password });
  writeLocalUsers(users);
  return user;
}

export function loginLocalUser(email, password) {
  const users = readLocalUsers();
  const normalizedEmail = normalizeEmail(email);
  const found = users.find((u) => u.email === normalizedEmail && u.password === password);
  if (!found) {
    return null;
  }

  const { password: _password, ...user } = found;
  return user;
}

export function clearLocalAuthUsers() {
  localStorage.removeItem(LOCAL_STORAGE_KEY);
}
